import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'preview-image',
  templateUrl: './preview-image.component.html',
  styleUrls: ['./preview-image.component.scss'],
})
export class PreviewImageComponent {
  @Input() imageUrl: string | undefined;
  @Output() closeModalEvent = new EventEmitter();

  @HostListener('document:keydown.escape', ['$event']) onEscKeyPress(
    event: KeyboardEvent
  ): void {
    this.closeModal();
  }

  closeModal(): void {
    this.closeModalEvent.emit();
  }
}
